import { ReactElement } from 'react';
import { GetStaticPropsContext } from 'next';
import { Layout } from '../../../components/Layout';
import TransactionsPagePersonal from '../../../views/Transactions/Transactions.personal';

function Transactions() {
  return <TransactionsPagePersonal />;
}

export async function getStaticProps(ctx: GetStaticPropsContext) {
  return {
    props: {},
  };
}

export async function getStaticPaths() {
  const possiblePath = [[], ['bill-payment'], ['buy-crypto']];

  const paths = possiblePath.map((slug) => ({ params: { slug } }));
  return {
    paths,
    fallback: false,
  };
}

Transactions.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export default Transactions;
